// extracted by mini-css-extract-plugin
export default {"container":"style_container__dBc2K","card":"style_card__dQdTc"};